var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-annotation"},[(!_vm.publicView)?_c('span',{ref:"emptyAnnotation",class:[
      'annotation-value',
      _vm.showActionError &&
        _vm.editAnnotation &&
        _vm.editAnnotation.id === _vm.emptyAnnotationId() &&
        'error-editing',
      _vm.isEmptyAnnotationEditable() ? '' : 'label-empty',
      _vm.isAnnotationBeingEdited() && 'clicked',
    ],attrs:{"id":_vm.emptyAnnotationId(),"contenteditable":_vm.isEmptyAnnotationEditable()},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.saveEmptyAnnotationChanges.apply(null, arguments)},"click":_vm.handleEditEmptyAnnotation,"focus":_vm.handleEditEmptyAnnotation}},[(_vm.span && _vm.span.offset_string && _vm.isEmptyAnnotationEditable())?_c('span',[_vm._v(" "+_vm._s(_vm.span.offset_string)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t("no_data_found"))+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }